import { render, staticRenderFns } from "./page-dialog.vue?vue&type=template&id=4c0985e7&scoped=true"
import script from "./page-dialog.vue?vue&type=script&lang=js"
export * from "./page-dialog.vue?vue&type=script&lang=js"
import style0 from "./page-dialog.vue?vue&type=style&index=0&id=4c0985e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0985e7",
  null
  
)

export default component.exports